import React from 'react';
import DashboardTemplate from "../../Common/DashboardTemplate";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import TextField from '@material-ui/core/TextField';
import {TablePagination} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faPencilAlt,
    faTrash,
    faDownload,
    faLink
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import { followAppLink } from "../../../utils/appLink";
import { parseNumberInputValue, getNumberInputDisplayValue } from "../../../utils/numberInputUtils";
import PartDisplay from '../../Common/PartDisplay';
const { v4: uuid } = require('uuid');



let globalProps;

const invoiceTileStyle = {
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginTop: 12,
};

function InvoiceDetailsFrame({ asPage, title, onBack, open, onClose, customWidth, hasUnsavedChanges, onSubmit, submitConfirmMessage, children }) {
    if (asPage) {
        return (
            <div className="main-dashboard-root">
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <Button variant="outlined" className="success-button-lg" onClick={onBack}>
                        Back to Invoices
                    </Button>
                    <h1 style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', margin: 0, color: 'white', whiteSpace: 'nowrap' }}>
                        {title}
                    </h1>
                </div>
                <div className="container" style={{ maxWidth: 1600, ...invoiceTileStyle }}>
                    {children}
                </div>
            </div>
        );
    }
    return (
        <DrawerMenuRight
            title={title}
            open={open}
            onClose={onClose}
            customWidth={customWidth}
            hasUnsavedChanges={hasUnsavedChanges}
            onSubmit={onSubmit}
            submitConfirmMessage={submitConfirmMessage}
        >
            {children}
        </DrawerMenuRight>
    );
}

class AdminInvoices extends React.Component {
    state = {
        loading: true,
        user: null,
        permissions: [],
        adminUsers: [],
        vendors: [],
        parts: [],
        partFamilies: [],
        invoices: [],
        purchaseOrders: [],
        purchasedPartInvoices: [],
        page: 0,
        rowsPerPage: 100,
        searchTerm: '',
        
        // Invoice Creation
        createInvoiceOpen: false,
        newInvoiceNumber: '',
        newInvoiceFile: null,
        selectedVendor: '',
        selectedVendorForCreate: null,
        loadingLineItemsForCreate: false,
        outstandingLineItemsForCreate: [],
        selectedLineItemsForCreate: [],
        selectedLineItemsQuantitiesForCreate: {},
        selectedLineItemsUnitCostsForCreate: {},
        overrideInvoiceQuantityForCreate: false,
        savingInvoice: false,
        
        // Invoice Edit
        editingInvoice: null,
        outstandingLineItems: [],
        selectedLineItems: [],
        selectedLineItemsQuantities: {},
        outstandingLineItemsForEdit: [],
        selectedLineItemsForEdit: [],
        selectedLineItemsQuantitiesForEdit: {},
        selectedLineItemsUnitCostsForEdit: {},
        overrideInvoiceQuantityForEdit: false,
        selectedVendorForEdit: null,
        loadingLineItemsForEdit: false,
        
        // Invoice Details View
        invoiceDetailsOpen: false,
        viewingInvoice: null,
        invoiceLineItems: [],
        loadingInvoiceLineItems: false,
        isEditMode: false,
        
        // Sorting
        sortBy: 'partNumber',
        sortDirection: 'asc',
        
        // Invoice table sorting
        invoiceSortBy: 'dateCreated',
        invoiceSortDirection: 'desc',
        
        // Search
        lineItemsSearchTerm: ''
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const invoiceId = this.props.match?.params?.invoiceId;
        const previousInvoiceId = prevProps.match?.params?.invoiceId;
        if (invoiceId && invoiceId !== previousInvoiceId) {
            this.openInvoicePage(invoiceId);
        } else if (!invoiceId && previousInvoiceId && (this.state.invoiceDetailsOpen || this.state.viewingInvoice)) {
            this.handleCloseInvoiceDetails();
        }
    }

    openInvoicePage = async (invoiceId) => {
        if (!invoiceId) return;
        if (this.state.viewingInvoice && String(this.state.viewingInvoice.id).toLowerCase() === String(invoiceId).toLowerCase() && !this.state.loading) {
            return;
        }

        const listedInvoice = (this.state.invoices || []).find((invoice) => String(invoice.id).toLowerCase() === String(invoiceId).toLowerCase());
        let invoice = listedInvoice || null;
        if (!invoice) {
            try {
                invoice = await ServiceLocator.Instance.getPartService().getInvoiceById(invoiceId);
            } catch (error) {
                console.error('Error loading invoice:', error);
                invoice = null;
            }
        }

        if (!invoice) {
            this.setState({
                viewingInvoice: null,
                invoiceDetailsOpen: false,
                loadingInvoiceLineItems: false,
                invoiceLineItems: [],
            });
            return;
        }

        this.setState({
            invoiceDetailsOpen: true,
            viewingInvoice: invoice,
            invoiceLineItems: [],
            loadingInvoiceLineItems: true,
            isEditMode: false,
        });
        await this.loadInvoiceDetails(invoice);
    };
    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('invoices');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                searchTerm: savedSettings.searchTerm || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showDeactivated: savedSettings.showDeactivated || false,
                showOldRevs: savedSettings.showOldRevs || false
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs
        };
        filterPersistenceService.saveFilterSettings('invoices', settings);
    }

    loadData = () => {
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Purchase')) {
            globalProps.history.push('/login');
            return;
        }

        const keepInvoiceDrawerOpen = this.state.createInvoiceOpen || this.state.invoiceDetailsOpen;
        if (!keepInvoiceDrawerOpen) {
            this.setState({loading: true});
        }

        return Promise.all([
            this.loadInvoices(),
            this.loadPurchaseOrders(),
            this.loadVendors(),
            this.loadParts(),
            this.loadPurchasedPartInvoices()
        ]).then(([invoices, purchaseOrders, vendors, parts, purchasedPartInvoices]) => {
            return this.refreshOpenInvoiceLineItems().then((lineItemUpdates) => ({
                invoices,
                purchaseOrders,
                vendors,
                parts,
                purchasedPartInvoices,
                lineItemUpdates,
            }));
        }).then(({ invoices, lineItemUpdates }) => {
            const invoiceId = this.props.match?.params?.invoiceId;

            this.setState({
                loading: false,
                user,
                permissions: user.userPermissions,
                invoices: invoices || [],
                ...lineItemUpdates,
            }, () => {
                if (invoiceId) {
                    this.openInvoicePage(invoiceId);
                    return;
                }
                if (keepInvoiceDrawerOpen) {
                    return;
                }
                setTimeout(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();
                    }
                }, 100);
                this.handleHashParameter(invoices);
            });
        });
    };

    refreshOpenInvoiceLineItems = async () => {
        const partService = ServiceLocator.Instance.getPartService();
        const vendorsToLoad = [
            this.state.selectedVendorForCreate,
            this.state.selectedVendorForEdit,
            this.state.selectedVendor,
        ].filter(Boolean);
        const uniqueVendors = [...new Set(vendorsToLoad)];
        if (uniqueVendors.length === 0) {
            return {};
        }

        const loadedByVendor = {};
        await Promise.all(uniqueVendors.map(async (vendorName) => {
            loadedByVendor[vendorName] = await partService.getAllPurchasedPartsByVendor(vendorName);
        }));

        const updates = {};
        if (this.state.selectedVendorForCreate && loadedByVendor[this.state.selectedVendorForCreate]) {
            updates.outstandingLineItemsForCreate = loadedByVendor[this.state.selectedVendorForCreate];
        }
        if (this.state.selectedVendorForEdit && loadedByVendor[this.state.selectedVendorForEdit]) {
            updates.outstandingLineItemsForEdit = loadedByVendor[this.state.selectedVendorForEdit];
        }
        if (this.state.selectedVendor && loadedByVendor[this.state.selectedVendor]) {
            updates.outstandingLineItems = loadedByVendor[this.state.selectedVendor];
        }
        return updates;
    };

    handleHashParameter = (invoices) => {
        const hash = window.location.hash;
        if (hash && hash.startsWith('#invoice-')) {
            const invoiceId = hash.replace('#invoice-', '');
            const invoiceList = invoices || this.state.invoices;
            const invoice = invoiceList.find(inv => String(inv.id).toLowerCase() === String(invoiceId).toLowerCase());
            if (invoice) {
                followAppLink(this.props.history || globalProps.history, `/admin/invoices/${invoice.id}`);
            }
        }
    };

    loadInvoices = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllInvoices().then((invoices) => {
            this.setState({invoices});
            return invoices;
        });
    };

    loadPurchaseOrders = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getPurchaseOrders().then((purchaseOrders) => {
            this.setState({purchaseOrders});
            return purchaseOrders;
        });
    };

    loadVendors = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getVendorNames().then((vendors) => {
            this.setState({vendors});
            return vendors;
        });
    };

    loadParts = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllPartsExpanded().then((parts) => {
            this.setState({parts});
            return parts;
        });
    };

    loadPurchasedPartInvoices = () => {
        const partService = ServiceLocator.Instance.getPartService();
        return partService.getAllPurchasedPartInvoices().then((purchasedPartInvoices) => {
            this.setState({purchasedPartInvoices});
            return purchasedPartInvoices;
        });
    };

    // Helper method to get line item count for a specific invoice
    getLineItemCountForInvoice = (invoice) => {
        let count = 0;
        Object.values(this.state.purchasedPartInvoices).forEach(lineItemInvoices => {
            lineItemInvoices.forEach(lineItemInvoice => {
                if (lineItemInvoice.invoiceId === invoice.id) {
                    count++;
                }
            });
        });
        return count;
    };

    // Helper method to get vendor for an invoice in the table
    getVendorForInvoiceInTable = (invoice) => {
        // Get the first purchased part for this invoice from the purchasedPartInvoices data
        const invoiceId = invoice.id;
        
        // Look through all purchased part invoices to find the first one for this invoice
        for (const [purchasedPartId, invoiceAttachments] of Object.entries(this.state.purchasedPartInvoices)) {
            const attachment = invoiceAttachments.find(att => att.invoiceId === invoiceId);
            if (attachment) {
                // Found a purchased part for this invoice, now get the vendor from the purchase order
                for (const purchaseOrder of this.state.purchaseOrders) {
                    if (purchaseOrder.purchasedParts) {
                        const matchingPart = purchaseOrder.purchasedParts.find(pp => pp.id === purchasedPartId);
                        if (matchingPart) {
                            return purchaseOrder.vendorName || matchingPart.companyName || 'Unknown';
                        }
                    }
                }
            }
        }
        
        return 'Unknown';
    };

    handleCreateInvoice = () => {
        this.setState({
            createInvoiceOpen: true,
            newInvoiceNumber: '',
            newInvoiceFile: null,
        });
    };

    handleCloseCreateInvoice = () => {
        this.setState({
            createInvoiceOpen: false,
            newInvoiceNumber: '',
            newInvoiceFile: null,
            selectedVendorForCreate: null,
            outstandingLineItemsForCreate: [],
            selectedLineItemsForCreate: [],
            selectedLineItemsQuantitiesForCreate: {},
            overrideInvoiceQuantityForCreate: false,
            loadingLineItemsForCreate: false,
        });
    };

    hasCreateInvoiceUnsavedChanges = () => {
        return (
            this.state.newInvoiceNumber !== '' ||
            this.state.newInvoiceFile !== null ||
            this.state.selectedVendorForCreate !== null ||
            this.state.selectedLineItemsForCreate.length > 0 ||
            Object.keys(this.state.selectedLineItemsQuantitiesForCreate).length > 0
        );
    };

    handleVendorSelectionForCreate = async (event, newValue) => {
        this.setState({
            selectedVendorForCreate: newValue,
            selectedLineItemsForCreate: [], // Reset line item selection when vendor changes
            loadingLineItemsForCreate: true
        });

        if (newValue) {
            try {
                const partService = ServiceLocator.Instance.getPartService();
                const allLineItems = await partService.getAllPurchasedPartsByVendor(newValue);
                this.setState({
                    outstandingLineItemsForCreate: allLineItems,
                    loadingLineItemsForCreate: false
                });
            } catch (error) {
                console.error('Error loading line items:', error);
                window.$alertError('Failed to load line items for this vendor');
                this.setState({
                    outstandingLineItemsForCreate: [],
                    loadingLineItemsForCreate: false
                });
            }
        } else {
            this.setState({
                outstandingLineItemsForCreate: [],
                loadingLineItemsForCreate: false
            });
        }
    };

    handleLineItemToggleForCreate = (purchasedPartId) => {
        const isSelected = this.state.selectedLineItemsForCreate.includes(purchasedPartId);
        if (isSelected) {
            // Remove from selection and quantities
            const newQuantities = {...this.state.selectedLineItemsQuantitiesForCreate};
            const newUnitCosts = {...this.state.selectedLineItemsUnitCostsForCreate};
            delete newQuantities[purchasedPartId];
            delete newUnitCosts[purchasedPartId];
            this.setState({
                selectedLineItemsForCreate: this.state.selectedLineItemsForCreate.filter(id => id !== purchasedPartId),
                selectedLineItemsQuantitiesForCreate: newQuantities,
                selectedLineItemsUnitCostsForCreate: newUnitCosts
            });
        } else {
            // Add to selection and set default quantity to outstanding amount
            const lineItem = this.state.outstandingLineItemsForCreate.find(item => item.id === purchasedPartId);
            const defaultQuantity = lineItem ? this.getOutstandingQuantityForInvoice(lineItem) : 1;
            // Calculate unit cost directly to avoid side effects
            const quantity = lineItem ? (lineItem.quantityOrdered || 1) : 1;
            const calculatedUnitCost = quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
            this.setState({
                selectedLineItemsForCreate: [...this.state.selectedLineItemsForCreate, purchasedPartId],
                selectedLineItemsQuantitiesForCreate: {
                    ...this.state.selectedLineItemsQuantitiesForCreate,
                    [purchasedPartId]: defaultQuantity
                },
                selectedLineItemsUnitCostsForCreate: {
                    ...this.state.selectedLineItemsUnitCostsForCreate,
                    [purchasedPartId]: calculatedUnitCost.toString()
                }
            }, () => {
                // Autofocus the quantity input field for the newly selected item
                setTimeout(() => {
                    const quantityInput = document.querySelector(`input[data-purchased-part-id-create="${purchasedPartId}"]`);
                    if (quantityInput) {
                        quantityInput.focus();
                        quantityInput.select();
                    }
                }, 100);
            });
        }
    };

    handleSelectAllLineItemsForCreate = () => {
        // Get the filtered and sorted line items that are currently displayed
        const displayedLineItems = this.getLineItemsEligibleForCreateInvoice();
        
        const allLineItemIds = displayedLineItems.map(lineItem => lineItem.id);
        const allLineItemQuantities = {};
        const allLineItemUnitCosts = {};
        displayedLineItems.forEach(lineItem => {
            allLineItemQuantities[lineItem.id] = this.getOutstandingQuantityForInvoice(lineItem);
            // Calculate unit cost directly to avoid side effects
            const quantity = lineItem.quantityOrdered || 1;
            const calculatedUnitCost = quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
            allLineItemUnitCosts[lineItem.id] = calculatedUnitCost.toString();
        });
        
        this.setState({
            selectedLineItemsForCreate: allLineItemIds,
            selectedLineItemsQuantitiesForCreate: allLineItemQuantities,
            selectedLineItemsUnitCostsForCreate: allLineItemUnitCosts
        });
    };

    handleDeselectAllLineItemsForCreate = () => {
        this.setState({
            selectedLineItemsForCreate: [],
            selectedLineItemsQuantitiesForCreate: {},
            selectedLineItemsUnitCostsForCreate: {}
        });
    };

    handleLineItemQuantityChangeForCreate = (purchasedPartId, quantity) => {
        this.setState(prevState => ({
            selectedLineItemsQuantitiesForCreate: {
                ...prevState.selectedLineItemsQuantitiesForCreate,
                [purchasedPartId]: quantity
            }
        }));
    };

    handleLineItemUnitCostChangeForCreate = (purchasedPartId, unitCost) => {
        this.setState(prevState => ({
            selectedLineItemsUnitCostsForCreate: {
                ...prevState.selectedLineItemsUnitCostsForCreate,
                [purchasedPartId]: unitCost
            }
        }));
    };

    getUnitCostForLineItem = (lineItem) => {
        const unitCost = this.state.selectedLineItemsUnitCostsForCreate[lineItem.id];
        if (unitCost !== undefined) {
            return parseNumberInputValue(unitCost);
        }
        // Calculate unit cost from total price and quantity
        const quantity = lineItem.quantityOrdered || 1;
        return quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
    };

    getLineItemTotalCost = (lineItem) => {
        const quantity = this.state.selectedLineItemsQuantitiesForCreate[lineItem.id] || this.getOutstandingQuantityForInvoice(lineItem);
        const unitCost = this.getUnitCostForLineItem(lineItem);
        return parseNumberInputValue(quantity) * unitCost;
    };

    getInvoiceTotal = () => {
        let total = 0;
        this.getEligibleSelectedLineItemsForCreate().forEach((purchasedPartId) => {
            const lineItem = this.state.outstandingLineItemsForCreate.find((item) => item.id === purchasedPartId);
            if (lineItem) {
                total += this.getLineItemTotalCost(lineItem);
            }
        });
        return total;
    };

    handleSort = (column) => {
        const { sortBy, sortDirection } = this.state;
        const newSortDirection = sortBy === column && sortDirection === 'asc' ? 'desc' : 'asc';
        
        this.setState({
            sortBy: column,
            sortDirection: newSortDirection
        });
    };

    handleInvoiceSort = (column) => {
        const { invoiceSortBy, invoiceSortDirection } = this.state;
        const newSortDirection = invoiceSortBy === column && invoiceSortDirection === 'asc' ? 'desc' : 'asc';
        
        this.setState({
            invoiceSortBy: column,
            invoiceSortDirection: newSortDirection
        });
    };

    sortLineItems = (lineItems) => {
        const { sortBy, sortDirection } = this.state;
        
        return [...lineItems].sort((a, b) => {
            let aValue, bValue;
            let aSecondaryValue, bSecondaryValue;
            
            // Primary sort values
            if (sortBy === 'partNumber') {
                const partA = a.partId ? this.getPartDetails(a.partId) : null;
                const partB = b.partId ? this.getPartDetails(b.partId) : null;
                aValue = partA ? partA.partNumber : (a.partFamilyName || '');
                bValue = partB ? partB.partNumber : (b.partFamilyName || '');
                // Secondary sort by PO #
                aSecondaryValue = a.purchaseOrderNumber || '';
                bSecondaryValue = b.purchaseOrderNumber || '';
            } else if (sortBy === 'orderDate') {
                aValue = new Date(a.orderDate);
                bValue = new Date(b.orderDate);
                // Secondary sort by part number
                const partA = a.partId ? this.getPartDetails(a.partId) : null;
                const partB = b.partId ? this.getPartDetails(b.partId) : null;
                aSecondaryValue = partA ? partA.partNumber : (a.partFamilyName || '');
                bSecondaryValue = partB ? partB.partNumber : (b.partFamilyName || '');
            } else if (sortBy === 'purchaseOrderNumber') {
                aValue = a.purchaseOrderNumber || '';
                bValue = b.purchaseOrderNumber || '';
                // Secondary sort by part number
                const partA = a.partId ? this.getPartDetails(a.partId) : null;
                const partB = b.partId ? this.getPartDetails(b.partId) : null;
                aSecondaryValue = partA ? partA.partNumber : (a.partFamilyName || '');
                bSecondaryValue = partB ? partB.partNumber : (b.partFamilyName || '');
            } else if (sortBy === 'quantityOrdered') {
                aValue = a.quantityOrdered || 0;
                bValue = b.quantityOrdered || 0;
                // Secondary sort by part number
                const partA = a.partId ? this.getPartDetails(a.partId) : null;
                const partB = b.partId ? this.getPartDetails(b.partId) : null;
                aSecondaryValue = partA ? partA.partNumber : (a.partFamilyName || '');
                bSecondaryValue = partB ? partB.partNumber : (b.partFamilyName || '');
            } else if (sortBy === 'outstanding') {
                aValue = a.quantityOrdered - (a.quantityReceived || 0);
                bValue = b.quantityOrdered - (b.quantityReceived || 0);
                // Secondary sort by part number
                const partA = a.partId ? this.getPartDetails(a.partId) : null;
                const partB = b.partId ? this.getPartDetails(b.partId) : null;
                aSecondaryValue = partA ? partA.partNumber : (a.partFamilyName || '');
                bSecondaryValue = partB ? partB.partNumber : (b.partFamilyName || '');
            }
            
            // Primary sort comparison
            let primaryComparison = 0;
            if (sortDirection === 'asc') {
                primaryComparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
            } else {
                primaryComparison = aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
            }
            
            // If primary values are equal, use secondary sort
            if (primaryComparison === 0) {
                return aSecondaryValue < bSecondaryValue ? -1 : aSecondaryValue > bSecondaryValue ? 1 : 0;
            }
            
            return primaryComparison;
        });
    };

    getInvoiceLinePartName = (lineItem) => {
        const partDetails = lineItem?.partId ? this.getPartDetails(lineItem.partId) : null;
        return partDetails ? partDetails.partNumber : (lineItem?.partFamilyName || 'Unknown part');
    };

    validateSelectedInvoiceQuantities = (selectedIds, quantities, lineItems, getMaxQuantity, override) => {
        const overages = [];
        for (const purchasedPartId of selectedIds) {
            const quantity = parseNumberInputValue(quantities[purchasedPartId]);
            const lineItem = lineItems.find(item => item.id === purchasedPartId);
            const maxQuantity = lineItem ? getMaxQuantity(lineItem) : 0;

            if (!quantity || quantity <= 0) {
                window.$alertError('Please enter valid quantities for all selected line items');
                return false;
            }

            if (lineItem && quantity > maxQuantity) {
                const partName = this.getInvoiceLinePartName(lineItem);
                if (!override) {
                    window.$alertError(`Quantity for ${partName} cannot exceed ${maxQuantity} (outstanding amount). Check quantity override to invoice the overage.`);
                    return false;
                }
                overages.push(`${partName}: invoicing ${quantity}, outstanding ${maxQuantity}`);
            }
        }

        if (overages.length > 0) {
            const confirmed = window.confirm(
                `These quantities are above what is left on the purchase order:\n\n${overages.join('\n')}\n\nSave the invoice anyway?`
            );
            if (!confirmed) return false;
        }

        return true;
    };

    handleSaveInvoice = async () => {
        if (!this.state.newInvoiceNumber.trim()) {
            window.$alertError('Invoice number is required');
            return;
        }

        const eligibleSelectedIds = this.getEligibleSelectedLineItemsForCreate();

        if (eligibleSelectedIds.length > 0 && !this.validateSelectedInvoiceQuantities(
            eligibleSelectedIds,
            this.state.selectedLineItemsQuantitiesForCreate,
            this.state.outstandingLineItemsForCreate,
            (lineItem) => this.getOutstandingQuantityForInvoice(lineItem),
            this.state.overrideInvoiceQuantityForCreate
        )) {
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            const invoice = {
                id: uuid(),
                invoiceNumber: this.state.newInvoiceNumber,
                isPaid: false,
                userId: AuthenticationService.getInstance().getUserId()
            };

            // Create the invoice
            await partService.createInvoice(invoice, this.state.newInvoiceFile);

            // Attach to selected line items if any (exclude paid / ineligible lines)
            if (eligibleSelectedIds.length > 0) {
                // Update purchased parts with new unit costs if changed
                for (const purchasedPartId of eligibleSelectedIds) {
                    const lineItem = this.state.outstandingLineItemsForCreate.find(item => item.id === purchasedPartId);
                    const newUnitCost = this.state.selectedLineItemsUnitCostsForCreate[purchasedPartId];
                    
                    if (lineItem && newUnitCost !== undefined) {
                        // Find the actual PurchasedPart object from purchaseOrders
                        let actualPurchasedPart = null;
                        for (const purchaseOrder of this.state.purchaseOrders) {
                            if (purchaseOrder.purchasedParts) {
                                actualPurchasedPart = purchaseOrder.purchasedParts.find(pp => pp.id === purchasedPartId);
                                if (actualPurchasedPart) break;
                            }
                        }
                        
                        if (actualPurchasedPart) {
                            const quantity = lineItem.quantityOrdered || 1;
                            const newTotalPrice = parseFloat(newUnitCost) * quantity;
                            
                            // Update the purchased part with new unit cost
                            await partService.updatePurchaseLog({
                                ...actualPurchasedPart,
                                pricePaid: newTotalPrice
                            });
                        } else {
                            console.warn(`Could not find PurchasedPart with ID ${purchasedPartId} in purchaseOrders`);
                        }
                    }
                }
                
                const quantitiesForBulk = {};
                eligibleSelectedIds.forEach((id) => {
                    quantitiesForBulk[id] = this.state.selectedLineItemsQuantitiesForCreate[id];
                });
                await partService.bulkAttachInvoiceToPurchasedParts(invoice.id, quantitiesForBulk);
                window.$alertSuccess(`Invoice created and attached to ${eligibleSelectedIds.length} line item(s) successfully`);
            } else {
                window.$alertSuccess('Invoice created successfully');
            }
            
            this.handleCloseCreateInvoice();
            await this.loadData();
        } catch (error) {
            console.error('Error creating invoice:', error);
            window.$alertError('Failed to create invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };



    hasEditInvoiceUnsavedChanges = () => {
        if (!this.state.editingInvoice || !this.state.editingInvoiceOriginal) return false;
        
        const hasInvoiceNumberChanged = this.state.editingInvoice.invoiceNumber !== this.state.editingInvoiceOriginal.invoiceNumber;
        const hasFileChanged = this.state.newInvoiceFile !== null;
        
        // Check if line items have changed
        const originalLineItemIds = this.state.invoiceLineItems.map(item => item.id).sort();
        const currentLineItemIds = this.state.selectedLineItemsForEdit.sort();
        const hasLineItemsChanged = JSON.stringify(originalLineItemIds) !== JSON.stringify(currentLineItemIds);
        
        return hasInvoiceNumberChanged || hasFileChanged || hasLineItemsChanged;
    };

    handleUpdateInvoice = async () => {
        if (this.state.selectedLineItemsForEdit.length > 0 && !this.validateSelectedInvoiceQuantities(
            this.state.selectedLineItemsForEdit,
            this.state.selectedLineItemsQuantitiesForEdit,
            this.state.outstandingLineItemsForEdit,
            (lineItem) => this.getOutstandingQuantityForInvoiceEdit(lineItem),
            this.state.overrideInvoiceQuantityForEdit
        )) {
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Update invoice details
            if (this.state.editingInvoice) {
                await partService.updateInvoice(this.state.editingInvoice);
            }
            
            // Update file if a new one was selected
            if (this.state.newInvoiceFile && this.state.viewingInvoice) {
                await partService.updateInvoiceFile(this.state.viewingInvoice.id, this.state.newInvoiceFile);
            }
            
            // Handle line item changes - always detach existing line items first
            // First, detach all existing line items from this invoice
            for (const lineItem of this.state.invoiceLineItems) {
                await partService.detachInvoiceFromPurchasedPart(lineItem.id, this.state.viewingInvoice.id);
            }
            
            // Then attach the new selection if there are any line items
            if (this.state.selectedLineItemsForEdit.length > 0) {
                await partService.bulkAttachInvoiceToPurchasedParts(this.state.viewingInvoice.id, this.state.selectedLineItemsQuantitiesForEdit);
                
                // Update unit costs if changed
                for (const purchasedPartId of this.state.selectedLineItemsForEdit) {
                    const lineItem = this.state.outstandingLineItemsForEdit.find(item => item.id === purchasedPartId);
                    const newUnitCost = this.state.selectedLineItemsUnitCostsForEdit[purchasedPartId];
                    
                    if (lineItem && newUnitCost !== undefined) {
                        // Find the actual PurchasedPart object from purchaseOrders
                        let actualPurchasedPart = null;
                        for (const purchaseOrder of this.state.purchaseOrders) {
                            if (purchaseOrder.purchasedParts) {
                                actualPurchasedPart = purchaseOrder.purchasedParts.find(pp => pp.id === purchasedPartId);
                                if (actualPurchasedPart) break;
                            }
                        }
                        
                        if (actualPurchasedPart) {
                            const quantity = lineItem.quantityOrdered || 1;
                            const newTotalPrice = parseFloat(newUnitCost) * quantity;
                            
                            // Update the purchased part with new unit cost
                            await partService.updatePurchaseLog({
                                ...actualPurchasedPart,
                                pricePaid: newTotalPrice
                            });
                        }
                    }
                }
            }
            
            window.$alertSuccess('Invoice updated successfully');
            
            // Reload the main data first
            await this.loadData();
            
            // Then reload the specific invoice details to show the updated information
            if (this.state.viewingInvoice) {
                this.setState({ loadingInvoiceLineItems: true });
                await this.loadInvoiceDetails(this.state.viewingInvoice);
            }
            
            this.setState({
                isEditMode: false,
                editingInvoice: null,
                editingInvoiceOriginal: null,
                newInvoiceFile: null,
                outstandingLineItemsForEdit: [],
                selectedLineItemsForEdit: [],
                selectedLineItemsQuantitiesForEdit: {},
                selectedLineItemsUnitCostsForEdit: {},
                selectedVendorForEdit: null,
                loadingLineItemsForEdit: false
            });
        } catch (error) {
            console.error('Error updating invoice:', error);
            window.$alertError('Failed to update invoice');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    handleDeleteInvoice = async (invoiceId) => {
        const lineItemCount = this.getLineItemCountForInvoice({id: invoiceId});
        
        if (lineItemCount > 0) {
            window.$alertError(`Cannot delete invoice. It is attached to ${lineItemCount} line item(s). Please detach it from all line items first.`);
            return;
        }

        if (!window.confirm('Are you sure you want to delete this invoice?')) {
            return;
        }

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.deleteInvoice(invoiceId);
            
            window.$alertSuccess('Invoice deleted successfully');
            await this.loadData();
        } catch (error) {
            console.error('Error deleting invoice:', error);
            window.$alertError('Failed to delete invoice');
        }
    };

    handleTogglePaidStatus = async (invoice) => {
        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.updateInvoicePaidStatus(invoice.id, !invoice.isPaid);
            
            window.$alertSuccess(`Invoice marked as ${!invoice.isPaid ? 'paid' : 'unpaid'}`);
            await this.loadData();
        } catch (error) {
            console.error('Error updating paid status:', error);
            window.$alertError('Failed to update paid status');
        }
    };

    handleViewInvoiceDetails = async (invoice) => {
        // Show loading state
        this.setState({
            invoiceDetailsOpen: true,
            viewingInvoice: invoice,
            invoiceLineItems: [],
            loadingInvoiceLineItems: true,
            isEditMode: false
        });

        await this.loadInvoiceDetails(invoice);
    };

    // Helper method to load invoice details (used by both detail view and attachment drawer)
    loadInvoiceDetails = async (invoice, purchasedPartInvoices, vendors) => {
        try {
            const attachmentMap = purchasedPartInvoices || this.state.purchasedPartInvoices || {};
            const vendorList = vendors || this.state.vendors || [];
            // Get line items for this invoice
            const invoiceLineItems = [];
            const purchasedPartIds = [];
            
            // First, collect all purchased part IDs for this invoice
            Object.entries(attachmentMap).forEach(([purchasedPartId, invoiceAttachments]) => {
                if (!Array.isArray(invoiceAttachments)) return;
                const attachment = invoiceAttachments.find(att => String(att.invoiceId).toLowerCase() === String(invoice.id).toLowerCase());
                if (attachment) {
                    purchasedPartIds.push({
                        id: purchasedPartId,
                        quantity: attachment.quantity || 0,
                        dateAttached: attachment.dateAttached
                    });
                }
            });

            // Try to find data in already loaded state first
            const foundLineItems = new Map();
            const allLineItems = [...(this.state.outstandingLineItems || []), ...(this.state.outstandingLineItemsForCreate || [])];
            
            allLineItems.forEach(lineItem => {
                foundLineItems.set(lineItem.id, lineItem);
            });

            // Check if we need to fetch additional data
            const missingIds = purchasedPartIds.filter(item => !foundLineItems.has(item.id));
            
            if (missingIds.length > 0) {
                // Fetch data for missing purchased parts by getting all purchased parts for all vendors
                const partService = ServiceLocator.Instance.getPartService();
                const allVendorData = await Promise.all(
                    vendorList.map(async (vendor) => {
                        try {
                            const vendorPurchasedParts = await partService.getAllPurchasedPartsByVendor(vendor);
                            return vendorPurchasedParts;
                        } catch (error) {
                            return [];
                        }
                    })
                );

                // Flatten and add to found items
                allVendorData.flat().forEach(lineItem => {
                    foundLineItems.set(lineItem.id, lineItem);
                });
            }

            // Build the final invoice line items array
            purchasedPartIds.forEach(({ id, quantity, dateAttached }) => {
                const lineItem = foundLineItems.get(id);
                if (lineItem) {
                    invoiceLineItems.push({
                        ...lineItem,
                        invoiceQuantity: quantity,
                        dateAttached: dateAttached
                    });
                } else {
                    // Still couldn't find it, create a placeholder
                    invoiceLineItems.push({
                        id: id,
                        partNumber: 'Unknown',
                        description: 'Could not load details',
                        quantityOrdered: 0,
                        quantityReceived: 0,
                        purchaseOrderNumber: 'Unknown',
                        invoiceQuantity: quantity,
                        dateAttached: dateAttached
                    });
                }
            });

            this.setState({
                invoiceLineItems: invoiceLineItems,
                loadingInvoiceLineItems: false
            });

        } catch (error) {
            console.error('Error loading invoice details:', error);
            window.$alertError('Failed to load invoice details');
            this.setState({
                invoiceLineItems: [],
                loadingInvoiceLineItems: false
            });
        }
    };

    handleCloseInvoiceDetails = () => {
        if (this.props.match?.params?.invoiceId) {
            followAppLink(this.props.history || globalProps.history, '/admin/invoices');
        }
        this.setState({
            invoiceDetailsOpen: false,
            viewingInvoice: null,
            invoiceLineItems: [],
            loadingInvoiceLineItems: false,
            isEditMode: false,
            editingInvoice: null,
            editingInvoiceOriginal: null,
            newInvoiceFile: null,
            outstandingLineItemsForEdit: [],
            selectedLineItemsForEdit: [],
            selectedLineItemsQuantitiesForEdit: {},
            selectedLineItemsUnitCostsForEdit: {},
            overrideInvoiceQuantityForEdit: false,
            selectedVendorForEdit: null,
            loadingLineItemsForEdit: false
        });
    };

    handleToggleEditMode = async () => {
        const wasInEditMode = this.state.isEditMode;
        
        this.setState(prevState => {
            if (!prevState.isEditMode) {
                // Entering edit mode - initialize editing state
                const vendor = this.getVendorFromInvoice();
                return {
                    isEditMode: true,
                    editingInvoice: {...prevState.viewingInvoice},
                    editingInvoiceOriginal: JSON.parse(JSON.stringify(prevState.viewingInvoice)),
                    newInvoiceFile: null,
                    outstandingLineItemsForEdit: [],
                    selectedLineItemsForEdit: [],
                    selectedLineItemsQuantitiesForEdit: {},
                    selectedLineItemsUnitCostsForEdit: {},
                    selectedVendorForEdit: vendor,
                    loadingLineItemsForEdit: true
                };
            } else {
                // Exiting edit mode - clear editing state
                return {
                    isEditMode: false,
                    editingInvoice: null,
                    editingInvoiceOriginal: null,
                    newInvoiceFile: null,
                    outstandingLineItemsForEdit: [],
                    selectedLineItemsForEdit: [],
                    selectedLineItemsQuantitiesForEdit: {},
                    selectedLineItemsUnitCostsForEdit: {},
                    selectedVendorForEdit: null,
                    loadingLineItemsForEdit: false
                };
            }
        });

        // If entering edit mode, load the vendor and line items
        if (!wasInEditMode) {
            const vendor = this.getVendorFromInvoice();
            if (vendor) {
                await this.handleVendorSelectionForEdit(null, vendor);
            }
        }
    };

    getVendorFromInvoice = () => {
        if (!this.state.viewingInvoice || this.state.loadingInvoiceLineItems || !this.state.invoiceLineItems.length) return null;
        
        // First, check if the line items already have vendor information
        const firstLineItem = this.state.invoiceLineItems[0];
        
        // Check if line item has companyName directly (this is the vendor name)
        if (firstLineItem.companyName) {
            return firstLineItem.companyName;
        }
        
        // Get vendor from the first line item by looking up the purchase order
        if (!firstLineItem || !firstLineItem.purchaseOrderNumber) return null;
        
        // Find the purchase order that contains this line item
        for (const purchaseOrder of this.state.purchaseOrders) {
            if (purchaseOrder.purchasedParts) {
                const matchingPart = purchaseOrder.purchasedParts.find(pp => pp.id === firstLineItem.id);
                if (matchingPart) {
                    console.log('Found vendor:', purchaseOrder.vendorName, 'for line item:', firstLineItem.id);
                    return purchaseOrder.vendorName || null;
                }
            }
        }
        
        // If we can't find by ID, try to find by purchase order number
        if (firstLineItem.purchaseOrderNumber) {
            const matchingPO = this.state.purchaseOrders.find(po => 
                po.purchaseOrderNumber === firstLineItem.purchaseOrderNumber
            );
            if (matchingPO) {
                console.log('Found vendor by PO number:', matchingPO.vendorName, 'for PO:', firstLineItem.purchaseOrderNumber);
                return matchingPO.vendorName || null;
            }
        }
        
        console.log('Could not find vendor for line item:', firstLineItem.id, 'PO:', firstLineItem.purchaseOrderNumber);
        console.log('Available purchase orders:', this.state.purchaseOrders.map(po => ({ id: po.id, vendorName: po.vendorName, purchasedPartsCount: po.purchasedParts?.length || 0 })));
        return null;
    };

    getVendorForInvoiceInTable = (invoice) => {
        // Get the first purchased part for this invoice from the purchasedPartInvoices data
        const invoiceId = invoice.id;
        
        // Look through all purchased part invoices to find the first one for this invoice
        for (const [purchasedPartId, invoiceAttachments] of Object.entries(this.state.purchasedPartInvoices)) {
            const attachment = invoiceAttachments.find(att => att.invoiceId === invoiceId);
            if (attachment) {
                // Found a purchased part for this invoice, now get the vendor from the purchase order
                for (const purchaseOrder of this.state.purchaseOrders) {
                    if (purchaseOrder.purchasedParts) {
                        const matchingPart = purchaseOrder.purchasedParts.find(pp => pp.id === purchasedPartId);
                        if (matchingPart) {
                            return purchaseOrder.vendorName || matchingPart.companyName || 'Unknown';
                        }
                    }
                }
            }
        }
        
        return 'Unknown';
    };

    handleVendorSelectionForEdit = async (event, newValue) => {
        // This should be auto-filled and disabled, but just in case
        if (newValue && newValue !== this.state.selectedVendorForEdit) {
            this.setState({
                selectedVendorForEdit: newValue,
                selectedLineItemsForEdit: [],
                loadingLineItemsForEdit: true
            });

            try {
                const partService = ServiceLocator.Instance.getPartService();
                const allLineItems = await partService.getAllPurchasedPartsByVendor(newValue);
                
                // Pre-select existing line items
                const existingLineItemIds = this.state.invoiceLineItems.map(item => item.id);
                const existingQuantities = {};
                const existingUnitCosts = {};
                
                this.state.invoiceLineItems.forEach(item => {
                    existingQuantities[item.id] = item.invoiceQuantity || 0;
                    // Calculate unit cost from total price and quantity
                    const quantity = item.quantityOrdered || 1;
                    existingUnitCosts[item.id] = quantity > 0 ? (item.pricePaid || 0) / quantity : 0;
                });

                this.setState({
                    outstandingLineItemsForEdit: allLineItems,
                    selectedLineItemsForEdit: existingLineItemIds,
                    selectedLineItemsQuantitiesForEdit: existingQuantities,
                    selectedLineItemsUnitCostsForEdit: existingUnitCosts,
                    loadingLineItemsForEdit: false
                });
            } catch (error) {
                console.error('Error loading line items:', error);
                window.$alertError('Failed to load line items for this vendor');
                this.setState({
                    outstandingLineItemsForEdit: [],
                    loadingLineItemsForEdit: false
                });
            }
        }
    };

    handleLineItemToggleForEdit = (purchasedPartId) => {
        const isSelected = this.state.selectedLineItemsForEdit.includes(purchasedPartId);
        if (isSelected) {
            // Remove from selection and quantities
            const newQuantities = {...this.state.selectedLineItemsQuantitiesForEdit};
            const newUnitCosts = {...this.state.selectedLineItemsUnitCostsForEdit};
            delete newQuantities[purchasedPartId];
            delete newUnitCosts[purchasedPartId];
            this.setState({
                selectedLineItemsForEdit: this.state.selectedLineItemsForEdit.filter(id => id !== purchasedPartId),
                selectedLineItemsQuantitiesForEdit: newQuantities,
                selectedLineItemsUnitCostsForEdit: newUnitCosts
            });
        } else {
            // Add to selection and set default quantity to outstanding amount
            const lineItem = this.state.outstandingLineItemsForEdit.find(item => item.id === purchasedPartId);
            const defaultQuantity = lineItem ? this.getOutstandingQuantityForInvoiceEdit(lineItem) : 1;
            // Calculate unit cost directly to avoid side effects
            const quantity = lineItem ? (lineItem.quantityOrdered || 1) : 1;
            const calculatedUnitCost = quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
            this.setState({
                selectedLineItemsForEdit: [...this.state.selectedLineItemsForEdit, purchasedPartId],
                selectedLineItemsQuantitiesForEdit: {
                    ...this.state.selectedLineItemsQuantitiesForEdit,
                    [purchasedPartId]: defaultQuantity
                },
                selectedLineItemsUnitCostsForEdit: {
                    ...this.state.selectedLineItemsUnitCostsForEdit,
                    [purchasedPartId]: calculatedUnitCost.toString()
                }
            });
        }
    };

         handleSelectAllLineItemsForEdit = () => {
         // Get the filtered and sorted line items that are currently displayed
         const displayedLineItems = this.sortLineItems(
             this.filterOutstandingLineItems(
                 this.state.outstandingLineItemsForEdit.filter((lineItem) => {
                     const outstandingForInvoice = this.getOutstandingQuantityForInvoiceEdit(lineItem);
                     const isAlreadyAttachedToCurrentInvoice = this.state.invoiceLineItems.some(item => item.id === lineItem.id);
                     return outstandingForInvoice > 0 || isAlreadyAttachedToCurrentInvoice;
                 })
             )
         );
         
         const allLineItemIds = displayedLineItems.map(lineItem => lineItem.id);
         const allLineItemQuantities = {};
         const allLineItemUnitCosts = {};
         
         displayedLineItems.forEach(lineItem => {
             allLineItemQuantities[lineItem.id] = this.getOutstandingQuantityForInvoiceEdit(lineItem);
             // Calculate unit cost directly to avoid side effects
             const quantity = lineItem.quantityOrdered || 1;
             const calculatedUnitCost = quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
             allLineItemUnitCosts[lineItem.id] = calculatedUnitCost.toString();
         });
        
        this.setState({
            selectedLineItemsForEdit: allLineItemIds,
            selectedLineItemsQuantitiesForEdit: allLineItemQuantities,
            selectedLineItemsUnitCostsForEdit: allLineItemUnitCosts
        });
    };

    handleDeselectAllLineItemsForEdit = () => {
        this.setState({
            selectedLineItemsForEdit: [],
            selectedLineItemsQuantitiesForEdit: {},
            selectedLineItemsUnitCostsForEdit: {}
        });
    };

    handleLineItemQuantityChangeForEdit = (purchasedPartId, quantity) => {
        this.setState(prevState => ({
            selectedLineItemsQuantitiesForEdit: {
                ...prevState.selectedLineItemsQuantitiesForEdit,
                [purchasedPartId]: quantity
            }
        }));
    };

    handleLineItemUnitCostChangeForEdit = (purchasedPartId, unitCost) => {
        this.setState(prevState => ({
            selectedLineItemsUnitCostsForEdit: {
                ...prevState.selectedLineItemsUnitCostsForEdit,
                [purchasedPartId]: unitCost
            }
        }));
    };

    getUnitCostForLineItemEdit = (lineItem) => {
        const unitCost = this.state.selectedLineItemsUnitCostsForEdit[lineItem.id];
        if (unitCost !== undefined) {
            return parseNumberInputValue(unitCost);
        }
        // Calculate unit cost from total price and quantity
        const quantity = lineItem.quantityOrdered || 1;
        return quantity > 0 ? (lineItem.pricePaid || 0) / quantity : 0;
    };

    getLineItemTotalCostForEdit = (lineItem) => {
        const quantity = this.state.selectedLineItemsQuantitiesForEdit[lineItem.id] || this.getOutstandingQuantityForInvoiceEdit(lineItem);
        const unitCost = this.getUnitCostForLineItemEdit(lineItem);
        return parseNumberInputValue(quantity) * unitCost;
    };

    getInvoiceTotalForEdit = () => {
        let total = 0;
        this.state.selectedLineItemsForEdit.forEach(purchasedPartId => {
            const lineItem = this.state.outstandingLineItemsForEdit.find(item => item.id === purchasedPartId);
            if (lineItem) {
                total += this.getLineItemTotalCostForEdit(lineItem);
            }
        });
        return total;
    };



    handleDetachLineItem = async (purchasedPartId) => {
        if (!this.state.viewingInvoice) {
            window.$alertError('No invoice selected for detachment');
            return;
        }

        const lineItem = this.state.invoiceLineItems.find(item => item.id === purchasedPartId);
        const partDetails = lineItem?.partId ? this.getPartDetails(lineItem.partId) : null;
        const partName = partDetails ? partDetails.partNumber : (lineItem?.partFamilyName || 'Unknown part');

        const confirmed = window.confirm(
            `Are you sure you want to detach ${partName} (Qty: ${lineItem?.invoiceQuantity || 0}) from invoice ${this.state.viewingInvoice.invoiceNumber}?`
        );

        if (!confirmed) return;

        try {
            const partService = ServiceLocator.Instance.getPartService();
            await partService.detachInvoiceFromPurchasedPart(purchasedPartId, this.state.viewingInvoice.id);

            window.$alertSuccess(`Line item detached from invoice successfully`);
            
            // Reload data to reflect changes
            await this.loadData();
            
            // Reload the invoice details for the current invoice
            await this.loadInvoiceDetails(this.state.viewingInvoice);

        } catch (error) {
            console.error('Error detaching line item:', error);
            window.$alertError('Failed to detach line item from invoice');
        }
    };



    handleVendorSelection = async (event, newValue) => {
        this.setState({
            selectedVendor: newValue,
            selectedLineItems: [], // Reset line item selection when vendor changes
            selectedLineItemsQuantities: {}, // Reset quantities when vendor changes
            loadingLineItems: true
        });

        if (newValue) {
            try {
                const partService = ServiceLocator.Instance.getPartService();
                const allLineItems = await partService.getAllPurchasedPartsByVendor(newValue);
                this.setState({
                    outstandingLineItems: allLineItems,
                    loadingLineItems: false
                });
            } catch (error) {
                console.error('Error loading line items:', error);
                window.$alertError('Failed to load line items for this vendor');
                this.setState({
                    outstandingLineItems: [],
                    loadingLineItems: false
                });
            }
        } else {
            this.setState({
                outstandingLineItems: [],
                loadingLineItems: false
            });
        }
    };

    handleLineItemToggle = (purchasedPartId) => {
        const isSelected = this.state.selectedLineItems.includes(purchasedPartId);
        if (isSelected) {
            // Remove from selection and quantities
            const newQuantities = {...this.state.selectedLineItemsQuantities};
            delete newQuantities[purchasedPartId];
            this.setState({
                selectedLineItems: this.state.selectedLineItems.filter(id => id !== purchasedPartId),
                selectedLineItemsQuantities: newQuantities
            });
        } else {
            // Add to selection and set default quantity to outstanding amount
            const lineItem = this.state.outstandingLineItems.find(item => item.id === purchasedPartId);
            const defaultQuantity = lineItem ? this.getOutstandingQuantityForInvoice(lineItem) : 1;
            this.setState({
                selectedLineItems: [...this.state.selectedLineItems, purchasedPartId],
                selectedLineItemsQuantities: {
                    ...this.state.selectedLineItemsQuantities,
                    [purchasedPartId]: defaultQuantity
                }
            }, () => {
                // Autofocus the quantity input field for the newly selected item
                setTimeout(() => {
                    const quantityInput = document.querySelector(`input[data-purchased-part-id-attach="${purchasedPartId}"]`);
                    if (quantityInput) {
                        quantityInput.focus();
                        quantityInput.select();
                    }
                }, 100);
            });
        }
    };

    handleSelectAllLineItems = () => {
        // Since we're filtering out items with invoices and fully received items,
        // we can select all visible items
        const allAvailableLineItems = this.state.outstandingLineItems
            .filter((lineItem) => {
                const fullyReceived = lineItem.quantityReceived >= lineItem.quantityOrdered;
                const outstandingForInvoice = this.getOutstandingQuantityForInvoice(lineItem);
                // Only exclude if fully received or no outstanding quantity for invoicing
                return !fullyReceived && outstandingForInvoice > 0;
            });
        
        const allLineItemIds = allAvailableLineItems.map(lineItem => lineItem.id);
        const allLineItemQuantities = {};
        allAvailableLineItems.forEach(lineItem => {
            allLineItemQuantities[lineItem.id] = this.getOutstandingQuantityForInvoice(lineItem);
        });
        
        this.setState({
            selectedLineItems: allLineItemIds,
            selectedLineItemsQuantities: allLineItemQuantities
        });
    };

    handleDeselectAllLineItems = () => {
        this.setState({
            selectedLineItems: [],
            selectedLineItemsQuantities: {}
        });
    };

    handleLineItemQuantityChange = (purchasedPartId, quantity) => {
        this.setState(prevState => ({
            selectedLineItemsQuantities: {
                ...prevState.selectedLineItemsQuantities,
                [purchasedPartId]: quantity
            }
        }));
    };

    handleLineItemsSearch = (event) => {
        const searchInput = event.target.value;
        this.setState({lineItemsSearchTerm: searchInput});
    };

    filterOutstandingLineItems = (lineItems) => {
        const searchTerm = this.state.lineItemsSearchTerm.toLowerCase();
        if (!searchTerm) return lineItems;
        
        return lineItems.filter(lineItem => {
            const partDetails = lineItem.partId ? this.getPartDetails(lineItem.partId) : null;
            const partNumber = partDetails ? partDetails.partNumber : (lineItem.partFamilyName || '');
            const description = partDetails ? partDetails.description : (lineItem.partFamilyName || '');
            
            return (
                (partNumber && partNumber.toLowerCase().includes(searchTerm)) ||
                (lineItem.purchaseOrderNumber && lineItem.purchaseOrderNumber.toString().toLowerCase().includes(searchTerm)) ||
                (description && description.toLowerCase().includes(searchTerm))
            );
        });
    };

    getInvoicesForLineItem = (purchasedPartId) => {
        return this.state.purchasedPartInvoices[purchasedPartId] || [];
    };

    /**
     * Hide create-invoice rows when PurchasedPart.isPaid, except when there is still split invoicing:
     * quantity already on other invoices and remaining "available for invoice" quantity both > 0.
     */
    isPurchaseLinePaidForInvoicing = (lineItem) => {
        if (!lineItem.isPaid) return false;
        const onOtherInvoices = this.getQuantityOnOtherInvoices(lineItem.id);
        const availableForInvoice = this.getOutstandingQuantityForInvoice(lineItem);
        if (onOtherInvoices > 0 && availableForInvoice > 0) return false;
        return true;
    };

    getLineItemsEligibleForCreateInvoice = () => {
        return this.sortLineItems(
            this.filterOutstandingLineItems(
                this.state.outstandingLineItemsForCreate.filter((lineItem) => {
                    const outstandingForInvoice = this.getOutstandingQuantityForInvoice(lineItem);
                    return outstandingForInvoice > 0 && !this.isPurchaseLinePaidForInvoicing(lineItem);
                })
            )
        );
    };

    getEligibleSelectedLineItemsForCreate = () => {
        return this.state.selectedLineItemsForCreate.filter((id) => {
            const lineItem = this.state.outstandingLineItemsForCreate.find((item) => item.id === id);
            if (!lineItem) return false;
            return (
                this.getOutstandingQuantityForInvoice(lineItem) > 0 &&
                !this.isPurchaseLinePaidForInvoicing(lineItem)
            );
        });
    };

    getQuantityOnOtherInvoices = (purchasedPartId) => {
        const invoices = this.getInvoicesForLineItem(purchasedPartId);
        return invoices.reduce((total, invoiceAttachment) => total + (invoiceAttachment.quantity || 0), 0);
    };

    getQuantityOnOtherInvoicesForEdit = (purchasedPartId) => {
        // For edit mode, we need to exclude quantities that are already on the current invoice being edited
        const invoices = this.getInvoicesForLineItem(purchasedPartId);
        const totalQuantityOnAllInvoices = invoices.reduce((total, invoiceAttachment) => total + (invoiceAttachment.quantity || 0), 0);
        
        // Subtract the quantity that's already on the current invoice being edited
        const quantityOnCurrentInvoice = this.state.invoiceLineItems.find(item => item.id === purchasedPartId)?.invoiceQuantity || 0;
        
        return Math.max(0, totalQuantityOnAllInvoices - quantityOnCurrentInvoice);
    };

    getOutstandingQuantityForInvoice = (lineItem) => {
        const quantityOnOtherInvoices = this.getQuantityOnOtherInvoices(lineItem.id);
        return Math.max(0, lineItem.quantityOrdered - quantityOnOtherInvoices);
    };

    getOutstandingQuantityForInvoiceEdit = (lineItem) => {
        // For edit mode, we need to exclude quantities that are already on the current invoice being edited
        const quantityOnOtherInvoices = this.getQuantityOnOtherInvoices(lineItem.id);
        const quantityOnCurrentInvoice = this.state.invoiceLineItems.find(item => item.id === lineItem.id)?.invoiceQuantity || 0;
        const totalQuantityOnInvoices = quantityOnOtherInvoices - quantityOnCurrentInvoice;
        return Math.max(0, lineItem.quantityOrdered - totalQuantityOnInvoices);
    };

    getPartDetails = (partId) => {
        const partExpanded = this.state.parts.find(p => p.part.id === partId);
        if (partExpanded) {
            return {
                partNumber: partExpanded.part.partId,
                revision: partExpanded.part.revision,
                description: partExpanded.part.description
            };
        }
        return {
            partNumber: 'Unknown Part',
            revision: '',
            description: ''
        };
    };

    handleSaveLineItemAttachments = async () => {
        if (this.state.selectedLineItems.length === 0) {
            window.$alertError('Please select at least one line item');
            return;
        }

        if (!this.validateSelectedInvoiceQuantities(
            this.state.selectedLineItems,
            this.state.selectedLineItemsQuantities,
            this.state.outstandingLineItems,
            (lineItem) => this.getOutstandingQuantityForInvoice(lineItem),
            this.state.overrideInvoiceQuantityForCreate
        )) {
            return;
        }

        this.setState({savingInvoice: true});
        
        try {
            const partService = ServiceLocator.Instance.getPartService();
            
            // Use bulk attachment with quantities
            await partService.bulkAttachInvoiceToPurchasedParts(this.state.viewingInvoice.id, this.state.selectedLineItemsQuantities);
            
            window.$alertSuccess(`Invoice attached to ${this.state.selectedLineItems.length} line item(s) successfully`);
            
            // Clear the selection and reload data
            this.setState({
                selectedVendor: null,
                outstandingLineItems: [],
                selectedLineItems: [],
                selectedLineItemsQuantities: {},
            });
            
            await this.loadData();
            await this.loadInvoiceDetails(this.state.viewingInvoice);
        } catch (error) {
            console.error('Error attaching invoice to line items:', error);
            window.$alertError('Failed to attach invoice to line items');
        } finally {
            this.setState({savingInvoice: false});
        }
    };

    download(url, filename) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
            const blob = xhr.response;
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        };
        xhr.open('GET', url);
        xhr.send();
    }

    handleViewInvoiceFile = (invoice) => {
        if (invoice.fileUrl) {
            this.download(invoice.fileUrl, invoice.fileName || 'invoice.pdf');
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleLineItemsSearch = (event) => {
        const searchInput = event.target.value;
        this.setState({lineItemsSearchTerm: searchInput});
    };

    getFilteredLineItems = () => {
        if (!this.state.lineItemsSearchTerm) {
            return this.state.outstandingLineItems;
        }
        
        const searchTerms = this.state.lineItemsSearchTerm.split(' ').filter(term => term.trim() !== '');
        if (searchTerms.length === 0) {
            return this.state.outstandingLineItems;
        }
        
        return this.state.outstandingLineItems.filter(lineItem => {
            // All search terms must match at least one field
            return searchTerms.every(term => {
                const searchTerm = term.toLowerCase();
                
                // Get part details
                const partDetails = lineItem.partId ? this.getPartDetails(lineItem.partId) : null;
                
                // Search in part number
                const partNumber = partDetails ? partDetails.partNumber : (lineItem.partFamilyName || '');
                if (partNumber.toLowerCase().includes(searchTerm)) return true;
                
                // Search in purchase order number
                if (lineItem.purchaseOrderNumber && lineItem.purchaseOrderNumber.toString().toLowerCase().includes(searchTerm)) return true;
                
                // Search in description
                const description = partDetails ? partDetails.description : (lineItem.partDescription || lineItem.partFamilyName || '');
                if (description.toLowerCase().includes(searchTerm)) return true;
                
                return false;
            });
        });
    };

    searchInvoices = (event) => {
        const searchInput = event.target.value;
        this.setState({searchTerm: event.target.value, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    filterInvoices = (invoices) => {
        const {searchTerm} = this.state;
        
        // First filter by search term if provided
        let filteredInvoices = invoices;
        if (searchTerm) {
            const searchTerms = searchTerm.split(' ').filter(term => term.trim() !== '');
            if (searchTerms.length > 0) {
                filteredInvoices = invoices.filter(invoice => {
                    // All search terms must match at least one field
                    return searchTerms.every(term => {
                        const searchTermLower = term.toLowerCase();
                        return (invoice.invoiceNumber && invoice.invoiceNumber.toLowerCase().includes(searchTermLower)) ||
                               (invoice.fileName && invoice.fileName.toLowerCase().includes(searchTermLower));
                    });
                });
            }
        }
        
        // Sort invoices based on current sort settings
        return filteredInvoices.sort((a, b) => {
            const { invoiceSortBy, invoiceSortDirection } = this.state;
            let aValue, bValue;
            
            if (invoiceSortBy === 'dateCreated') {
                aValue = new Date(a.dateCreated);
                bValue = new Date(b.dateCreated);
            } else if (invoiceSortBy === 'invoiceNumber') {
                aValue = a.invoiceNumber || '';
                bValue = b.invoiceNumber || '';
            } else if (invoiceSortBy === 'vendor') {
                aValue = this.getVendorForInvoiceInTable(a) || '';
                bValue = this.getVendorForInvoiceInTable(b) || '';
            } else if (invoiceSortBy === 'isPaid') {
                aValue = a.isPaid ? 1 : 0;
                bValue = b.isPaid ? 1 : 0;
            } else {
                // Default to dateCreated
                aValue = new Date(a.dateCreated);
                bValue = new Date(b.dateCreated);
            }
            
            if (invoiceSortDirection === 'asc') {
                return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
            } else {
                return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
            }
        });
    };

    render() {
        const {classes} = this.props;
        
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Invoices" onSyncDatabase={this.loadData}>
                    <div style={{textAlign: 'center', marginTop: '50px'}}>
                        <CircularProgress/>
                    </div>
                </DashboardTemplate>
            );
        }

        const filteredInvoices = this.filterInvoices(this.state.invoices);
        const paginatedInvoices = filteredInvoices.slice(
            this.state.page * this.state.rowsPerPage,
            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
        );

        const invoicePageId = this.props.match?.params?.invoiceId;

        return (
            <DashboardTemplate title={invoicePageId ? 'Invoice' : 'Invoices'} onSyncDatabase={this.loadData}>
                {!invoicePageId && (
                <div className="main-dashboard-root">
                    <div className="container" style={{maxWidth: '1400px'}}>
                        <div style={{position: 'relative', display: 'flex', alignItems: 'center', width: '100%', marginBottom: '20px'}}>
                            {/* Left: Search Bar */}
                            <div style={{flex: '1', display: 'flex', justifyContent: 'flex-start'}}>
                                <TextField
                                    label="Search invoices..."
                                    variant="outlined"
                                    value={this.state.searchTerm}
                                    onChange={this.searchInvoices}
                                    style={{width: 300}}
                                    inputRef={ref => this.searchInputRef = ref}
                                />
                            </div>
                            
                            {/* Center: Buttons - Absolutely centered */}
                            <div style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleCreateInvoice}
                                    className="success-button-lg"
                                >
                                    Create Invoice
                                </Button>
                            </div>
                            
                            {/* Right: Filter toggles */}
                            <div style={{flex: '1', display: 'flex', justifyContent: 'flex-end'}}>
                                {/* No filter toggles in this component */}
                            </div>
                        </div>
                    
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                colSpan={4}
                                count={filteredInvoices.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </center>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                    <tr>
                                        <th 
                                            style={{minWidth: 30, cursor: 'pointer', userSelect: 'none'}}
                                            onClick={() => this.handleInvoiceSort('isPaid')}
                                        >
                                            Paid {this.state.invoiceSortBy === 'isPaid' && (this.state.invoiceSortDirection === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th 
                                            style={{minWidth: 150, cursor: 'pointer', userSelect: 'none'}}
                                            onClick={() => this.handleInvoiceSort('invoiceNumber')}
                                        >
                                            Invoice Number {this.state.invoiceSortBy === 'invoiceNumber' && (this.state.invoiceSortDirection === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th 
                                            style={{minWidth: 150, cursor: 'pointer', userSelect: 'none'}}
                                            onClick={() => this.handleInvoiceSort('vendor')}
                                        >
                                            Vendor {this.state.invoiceSortBy === 'vendor' && (this.state.invoiceSortDirection === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th style={{minWidth: 120}}>File</th>
                                        <th 
                                            style={{minWidth: 100, cursor: 'pointer', userSelect: 'none'}}
                                            onClick={() => this.handleInvoiceSort('dateCreated')}
                                        >
                                            Created Date {this.state.invoiceSortBy === 'dateCreated' && (this.state.invoiceSortDirection === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th style={{minWidth: 80}}>Status</th>
                                        <th style={{minWidth: 120}}>Line Items</th>
                                        <th style={{minWidth: 30}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedInvoices.map((invoice) => {
                                        const lineItemCount = this.getLineItemCountForInvoice(invoice);
                                        return (
                                            <tr key={invoice.id}>
                                                <td style={{textAlign: 'center'}}>
                                                    <FontAwesomeIcon 
                                                        icon={faCheck} 
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: invoice.isPaid ? '#4caf50' : '#999',
                                                            fontSize: '16px'
                                                        }}
                                                        title={invoice.isPaid ? "Mark as Unpaid" : "Mark as Paid"}
                                                        onClick={() => this.handleTogglePaidStatus(invoice)}
                                                    />
                                                </td>
                                                <td className="text-left">
                                                    <a
                                                        href={`/admin/invoices/${invoice.id}`}
                                                        style={{
                                                            fontWeight: 'bold',
                                                            color: 'inherit',
                                                            textDecoration: 'none'
                                                        }}
                                                        onClick={(event) => followAppLink(this.props.history || globalProps.history, `/admin/invoices/${invoice.id}`, event)}
                                                        title="Click to view invoice. Ctrl+click opens it in a new tab."
                                                    >
                                                        {invoice.invoiceNumber}
                                                    </a>
                                                </td>
                                                <td className="text-left">
                                                    {this.getVendorForInvoiceInTable(invoice)}
                                                </td>
                                                <td>
                                                    {invoice.fileName ? (
                                                        <span 
                                                            style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                            onClick={() => this.handleViewInvoiceFile(invoice)}
                                                            title="Click to download"
                                                        >
                                                            <FontAwesomeIcon icon={faDownload} style={{marginRight: '5px'}} />
                                                            {invoice.fileName}
                                                        </span>
                                                    ) : ''}
                                                </td>
                                                <td>
                                                    {new Date(invoice.dateCreated).toISOString().split('T')[0]}
                                                </td>
                                                <td>
                                                    <span style={{
                                                        color: invoice.isPaid ? '#4caf50' : '#ff9800',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {invoice.isPaid ? 'PAID' : 'UNPAID'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{
                                                        color: lineItemCount > 0 ? '#4caf50' : '#666',
                                                        fontWeight: lineItemCount > 0 ? 'bold' : 'normal'
                                                    }}>
                                                        {lineItemCount} line item{lineItemCount !== 1 ? 's' : ''}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div style={{display: 'flex', gap: '5px', justifyContent: 'center'}}>
                                                        <FontAwesomeIcon 
                                                            icon={faTrash} 
                                                            style={{
                                                                cursor: lineItemCount > 0 ? 'not-allowed' : 'pointer', 
                                                                color: lineItemCount > 0 ? '#ccc' : '#f44336', 
                                                                fontSize: '16px'
                                                            }}
                                                            title={lineItemCount > 0 ? `Cannot delete - attached to ${lineItemCount} line items` : "Delete Invoice"}
                                                            onClick={() => this.handleDeleteInvoice(invoice.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 100]}
                                colSpan={4}
                                count={filteredInvoices.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </center>
                    </div>
                </div>
                )}

                {/* Create Invoice Drawer */}
                <DrawerMenuRight 
                    title="Create New Invoice"
                    open={this.state.createInvoiceOpen} 
                    onClose={this.handleCloseCreateInvoice}
                    customWidth={1400}
                    hasUnsavedChanges={this.hasCreateInvoiceUnsavedChanges()}
                    onSubmit={this.handleSaveInvoice}
                    submitConfirmMessage="Are you sure you want to create this invoice?"
                >
                    <div style={{padding: '20px'}}>
                        <div style={{display: 'flex', gap: '20px', marginBottom: '20px', alignItems: 'flex-start'}}>
                            <TextField
                                autoFocus
                                label="Invoice Number"
                                variant="outlined"
                                value={this.state.newInvoiceNumber}
                                onChange={(e) => this.setState({newInvoiceNumber: e.target.value})}
                                style={{flex: 1}}
                            />
                            <div
                                style={{
                                    flex: 1,
                                    border: '2px dashed #ccc',
                                    borderRadius: '4px',
                                    padding: '0',
                                    textAlign: 'center',
                                    backgroundColor: '#fafafa',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    minHeight: '51px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative'
                                }}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.style.borderColor = '#1976d2';
                                    e.currentTarget.style.backgroundColor = '#f0f8ff';
                                }}
                                onDragLeave={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.style.borderColor = '#ccc';
                                    e.currentTarget.style.backgroundColor = '#fafafa';
                                }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.style.borderColor = '#ccc';
                                    e.currentTarget.style.backgroundColor = '#fafafa';
                                    const files = e.dataTransfer.files;
                                    if (files.length > 0) {
                                        const file = files[0];
                                        if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                            this.setState({newInvoiceFile: file});
                                        }
                                    }
                                }}
                                onClick={() => document.getElementById('file-input').click()}
                            >
                                {this.state.newInvoiceFile ? (
                                    <div>
                                        <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                            ✓ File Selected
                                        </div>
                                        <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                            {this.state.newInvoiceFile.name}
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div style={{fontSize: '14px', color: '#666'}}>
                                            📎 Attach Invoice File
                                        </div>
                                        <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                            Drag & drop or click to upload
                                        </div>
                                    </div>
                                )}
                                <input
                                    id="file-input"
                                    type="file"
                                    onChange={(e) => this.setState({newInvoiceFile: e.target.files[0]})}
                                    style={{display: 'none'}}
                                />
                            </div>
                        </div>

                        <div style={{marginTop: '15px', marginBottom: '15px'}}>
                            <h4 style={{marginBottom: '10px'}}>Attach to Line Items (Optional)</h4>
                            <Autocomplete autoHighlight
                                options={this.state.vendors}
                                getOptionLabel={(option) => option}
                                value={this.state.selectedVendorForCreate}
                                onChange={this.handleVendorSelectionForCreate}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Select Vendor"
                                        placeholder="Choose a vendor to see their line items"
                                    />
                                )}
                                style={{marginBottom: '15px'}}
                            />
                        </div>

                        {this.state.loadingLineItemsForCreate && (
                            <div style={{textAlign: 'center', margin: '20px'}}>
                                <CircularProgress />
                                <div>Loading line items...</div>
                            </div>
                        )}

                        {this.state.selectedVendorForCreate && !this.state.loadingLineItemsForCreate && (
                            <>
                                <div style={{marginBottom: '10px', display: 'flex', gap: '10px', alignItems: 'center'}}>
                                    <Button 
                                        onClick={this.handleSelectAllLineItemsForCreate}
                                        variant="outlined"
                                        size="small"
                                    >
                                        Select All Available
                                    </Button>
                                    <Button 
                                        onClick={this.handleDeselectAllLineItemsForCreate}
                                        variant="outlined"
                                        size="small"
                                    >
                                        Deselect All
                                    </Button>
                                    <TextField
                                        label="Search by PN, PO #, or Description"
                                        variant="outlined"
                                        value={this.state.lineItemsSearchTerm}
                                        onChange={this.handleLineItemsSearch}
                                        style={{width: '300px'}}
                                        size="small"
                                    />
                                    <div style={{fontSize: '14px', color: '#666'}}>
                                        {this.getEligibleSelectedLineItemsForCreate().length} item(s) selected
                                    </div>
                                    <FormControlLabel
                                        className="validation-override"
                                        style={{ marginLeft: 'auto', marginRight: 0 }}
                                        control={
                                            <Checkbox
                                                checked={this.state.overrideInvoiceQuantityForCreate}
                                                onChange={(e) => this.setState({ overrideInvoiceQuantityForCreate: e.target.checked })}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label="Override quantity above ordered amount"
                                    />
                                </div>

                                <div className="parts-table-container" style={{width: '100%', maxHeight: '50vh', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px'}}>
                                    {this.state.outstandingLineItemsForCreate.length === 0 ? (
                                        <div style={{padding: '20px', textAlign: 'center', color: '#666'}}>
                                            No line items found for this vendor.
                                        </div>
                                    ) : this.getLineItemsEligibleForCreateInvoice().length === 0 ? (
                                        <div style={{padding: '20px', textAlign: 'center', color: '#666'}}>
                                            No line items available for invoicing (nothing left to attach, or every remaining line is marked paid on the purchase order).
                                        </div>
                                    ) : (
                                        <table className="parts-table" style={{fontSize: '14px'}}>
                                            <thead>
                                                <tr>
                                                    <th style={{minWidth: 50}}>Select</th>
                                                    <th 
                                                        style={{minWidth: 60, cursor: 'pointer', userSelect: 'none'}}
                                                        onClick={() => this.handleSort('purchaseOrderNumber')}
                                                    >
                                                        PO # {this.state.sortBy === 'purchaseOrderNumber' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th 
                                                        style={{minWidth: 90, cursor: 'pointer', userSelect: 'none'}}
                                                        onClick={() => this.handleSort('orderDate')}
                                                    >
                                                        PO Date {this.state.sortBy === 'orderDate' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th 
                                                        style={{minWidth: 110, cursor: 'pointer', userSelect: 'none'}}
                                                        onClick={() => this.handleSort('partNumber')}
                                                    >
                                                        PN {this.state.sortBy === 'partNumber' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th 
                                                        style={{minWidth: 60, cursor: 'pointer', userSelect: 'none'}}
                                                        onClick={() => this.handleSort('quantityOrdered')}
                                                    >
                                                        Ordered {this.state.sortBy === 'quantityOrdered' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                    </th>
                                                    <th style={{minWidth: 70}}>On Other<br/>Invoices</th>
                                                    <th style={{minWidth: 80}}>Available For<br/>Invoice</th>
                                                    <th style={{minWidth: 80}}>Invoice<br/>Quantity</th>
                                                    <th style={{minWidth: 90}}>Unit Cost</th>
                                                    <th style={{minWidth: 100}}>Line Item<br/>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.getLineItemsEligibleForCreateInvoice().map((lineItem) => {
                                                    const isSelected = this.state.selectedLineItemsForCreate.includes(lineItem.id);
                                                    const partDetails = lineItem.partId ? this.getPartDetails(lineItem.partId) : null;
                                                    const outstanding = lineItem.quantityOrdered - (lineItem.quantityReceived || 0);
                                                    
                                                    return (
                                                        <tr key={lineItem.id}>
                                                            <td>
                                                                <Checkbox
                                                                    checked={isSelected}
                                                                    onChange={() => this.handleLineItemToggleForCreate(lineItem.id)}
                                                                    color="primary"
                                                                />
                                                            </td>
                                                            <td>{lineItem.purchaseOrderNumber}</td>
                                                            <td>{new Date(lineItem.orderDate).toISOString().split('T')[0]}</td>
                                                            <td>
                                                                <PartDisplay 
                                                                    part={{
                                                                        partId: partDetails ? partDetails.partNumber : (lineItem.partFamilyName || 'Family Part'),
                                                                        revision: partDetails ? partDetails.revision || '' : '',
                                                                        description: partDetails ? partDetails.description : (lineItem.partFamilyName || 'Unknown')
                                                                    }}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            </td>
                                                            <td>{lineItem.quantityOrdered}</td>
                                                            <td style={{color: this.getQuantityOnOtherInvoices(lineItem.id) > 0 ? 'orange' : 'inherit', fontWeight: this.getQuantityOnOtherInvoices(lineItem.id) > 0 ? 'bold' : 'normal'}}>
                                                                {this.getQuantityOnOtherInvoices(lineItem.id) || 0}
                                                            </td>
                                                            <td style={{color: this.getOutstandingQuantityForInvoice(lineItem) > 0 ? 'green' : 'red', fontWeight: 'bold'}}>
                                                                {this.getOutstandingQuantityForInvoice(lineItem)}
                                                            </td>
                                                                                                                            <td>
                                                                    {isSelected ? (
                                                                        <TextField
                                                                            type="number"
                                                                            variant="outlined"
                                                                            error={!this.state.overrideInvoiceQuantityForCreate && parseNumberInputValue(this.state.selectedLineItemsQuantitiesForCreate?.[lineItem.id]) > this.getOutstandingQuantityForInvoice(lineItem)}
                                                                            value={getNumberInputDisplayValue(this.state.selectedLineItemsQuantitiesForCreate?.[lineItem.id] !== undefined ? this.state.selectedLineItemsQuantitiesForCreate[lineItem.id] : this.getOutstandingQuantityForInvoice(lineItem))}
                                                                            onChange={(e) => this.handleLineItemQuantityChangeForCreate(lineItem.id, e.target.value)}
                                                                            inputProps={{
                                                                                min: 1,
                                                                                ...(this.state.overrideInvoiceQuantityForCreate ? {} : { max: this.getOutstandingQuantityForInvoice(lineItem) }),
                                                                                'data-purchased-part-id-create': lineItem.id
                                                                            }}
                                                                            size="small"
                                                                            style={{width: 80}}
                                                                        />
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {isSelected ? (
                                                                        <TextField
                                                                            type="number"
                                                                            variant="outlined"
                                                                            value={getNumberInputDisplayValue(this.state.selectedLineItemsUnitCostsForCreate[lineItem.id] !== undefined ? this.state.selectedLineItemsUnitCostsForCreate[lineItem.id] : this.getUnitCostForLineItem(lineItem).toString())}
                                                                            onChange={(e) => this.handleLineItemUnitCostChangeForCreate(lineItem.id, e.target.value)}
                                                                            inputProps={{
                                                                                min: 0,
                                                                                step: 0.01,
                                                                                'data-purchased-part-id-create': lineItem.id
                                                                            }}
                                                                            size="small"
                                                                            style={{width: 80}}
                                                                        />
                                                                    ) : (
                                                                        <span>${this.getUnitCostForLineItem(lineItem).toFixed(2)}</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <span style={{fontWeight: 'bold'}}>
                                                                        ${this.getLineItemTotalCost(lineItem).toFixed(2)}
                                                                    </span>
                                                                </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                {this.state.selectedLineItemsForCreate.length > 0 && (
                                    <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#e3f2fd', borderRadius: '4px'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                            <strong>{this.state.selectedLineItemsForCreate.length} line item(s) selected for attachment</strong>
                                            <div style={{fontSize: '16px', fontWeight: 'bold'}}>
                                                Invoice Total: <span style={{color: '#1976d2'}}>${this.getInvoiceTotal().toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        <div style={{marginTop: '30px', display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
                            <Button onClick={this.handleCloseCreateInvoice}>Cancel</Button>
                            <Button 
                                onClick={this.handleSaveInvoice} 
                                variant="contained" 
                                color="primary"
                                disabled={this.state.savingInvoice}
                            >
                                {this.state.savingInvoice ? 'Creating...' : 
                                    this.state.selectedLineItemsForCreate.length > 0 ? 
                                        `Create & Attach to ${this.state.selectedLineItemsForCreate.length} Line Item(s)` : 
                                        'Create Invoice'
                                }
                            </Button>
                        </div>
                    </div>
                </DrawerMenuRight>





                {/* Invoice details. A direct link renders this as a page; the list can still open it as a drawer. */}
                <InvoiceDetailsFrame
                    asPage={!!this.props.match?.params?.invoiceId}
                    title={this.state.viewingInvoice ?
                        (this.state.isEditMode ?
                            `${this.state.viewingInvoice.invoiceNumber}` :
                            `${this.state.viewingInvoice.invoiceNumber}`
                        ) : ''
                    }
                    onBack={this.handleCloseInvoiceDetails}
                    open={this.state.invoiceDetailsOpen}
                    onClose={this.handleCloseInvoiceDetails}
                    customWidth={this.state.isEditMode ? 1400 : 1000}
                    hasUnsavedChanges={this.state.isEditMode && this.hasEditInvoiceUnsavedChanges()}
                    onSubmit={this.state.isEditMode ? this.handleUpdateInvoice : null}
                    submitConfirmMessage={this.state.isEditMode ? "Are you sure you want to update this invoice?" : null}
                >
                    <div style={{padding: '20px'}}>
                        {!this.state.viewingInvoice && (
                            <p>This invoice could not be loaded.</p>
                        )}
                        {this.state.viewingInvoice && (
                            <>
                                <div style={{marginBottom: '20px'}}>
                                    {this.state.isEditMode ? (
                                        <div style={{display: 'flex', gap: '20px', marginBottom: '20px', alignItems: 'flex-start'}}>
                                            <TextField
                                                autoFocus
                                                label="Invoice Number"
                                                variant="outlined"
                                                value={this.state.editingInvoice?.invoiceNumber || this.state.viewingInvoice.invoiceNumber}
                                                onChange={(e) => this.setState({
                                                    editingInvoice: {
                                                        ...this.state.editingInvoice,
                                                        invoiceNumber: e.target.value
                                                    }
                                                })}
                                                style={{flex: 1}}
                                            />
                                            <div
                                                style={{
                                                    flex: 1,
                                                    border: '2px dashed #ccc',
                                                    borderRadius: '4px',
                                                    padding: '0',
                                                    textAlign: 'center',
                                                    backgroundColor: '#fafafa',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease',
                                                    minHeight: '51px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    position: 'relative'
                                                }}
                                                onDragOver={(e) => {
                                                    e.preventDefault();
                                                    e.currentTarget.style.borderColor = '#1976d2';
                                                    e.currentTarget.style.backgroundColor = '#f0f8ff';
                                                }}
                                                onDragLeave={(e) => {
                                                    e.preventDefault();
                                                    e.currentTarget.style.borderColor = '#ccc';
                                                    e.currentTarget.style.backgroundColor = '#fafafa';
                                                }}
                                                onDrop={(e) => {
                                                    e.preventDefault();
                                                    e.currentTarget.style.borderColor = '#ccc';
                                                    e.currentTarget.style.backgroundColor = '#fafafa';
                                                    const files = e.dataTransfer.files;
                                                    if (files.length > 0) {
                                                        const file = files[0];
                                                        if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
                                                            this.setState({newInvoiceFile: file});
                                                        }
                                                    }
                                                }}
                                                onClick={() => document.getElementById('edit-file-input').click()}
                                            >
                                                {this.state.newInvoiceFile ? (
                                                    <div>
                                                        <div style={{fontSize: '14px', color: '#1976d2', fontWeight: 'bold'}}>
                                                            ✓ New File Selected
                                                        </div>
                                                        <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                                            {this.state.newInvoiceFile.name}
                                                        </div>
                                                    </div>
                                                ) : this.state.viewingInvoice.fileName ? (
                                                    <div>
                                                        <div style={{fontSize: '14px', color: '#666'}}>
                                                            Current: {this.state.viewingInvoice.fileName}
                                        </div>
                                        <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                            Click to replace
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div style={{fontSize: '14px', color: '#666'}}>
                                            📎 Attach Invoice File
                                        </div>
                                        <div style={{fontSize: '12px', color: '#999', marginTop: '4px'}}>
                                            Drag & drop or click to upload
                                        </div>
                                    </div>
                                )}
                                <input
                                    id="edit-file-input"
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={(e) => this.setState({newInvoiceFile: e.target.files[0]})}
                                    style={{display: 'none'}}
                                />
                            </div>
                        </div>
                    ) : (
                        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px'}}>
                            <div>
                                <strong>Invoice Number:</strong> {this.state.viewingInvoice.invoiceNumber}
                            </div>
                            <div>
                                <strong>Status:</strong> 
                                <span style={{
                                    color: this.state.viewingInvoice.isPaid ? '#4caf50' : '#ff9800',
                                    fontWeight: 'bold',
                                    marginLeft: '10px'
                                }}>
                                    {this.state.viewingInvoice.isPaid ? 'PAID' : 'UNPAID'}
                                </span>
                            </div>
                            <div>
                                <strong>Created Date:</strong> {this.state.viewingInvoice.dateCreated ? new Date(this.state.viewingInvoice.dateCreated).toLocaleDateString() : '-'}
                            </div>
                            <div>
                                <strong>File:</strong> {this.state.viewingInvoice.fileName || 'None'}
                            </div>
                        </div>
                    )}
                                </div>

                                {this.state.isEditMode ? (
                                    <>
                                        <div style={{marginTop: '15px', marginBottom: '15px'}}>
                                            <h4 style={{marginBottom: '10px'}}>Line Items</h4>
                                            <Autocomplete autoHighlight
                                                options={this.state.vendors}
                                                getOptionLabel={(option) => option}
                                                value={(() => {
                                                    const selectedVendor = this.state.selectedVendorForEdit;
                                                    const vendorFromInvoice = this.getVendorFromInvoice();
                                                    return selectedVendor || vendorFromInvoice;
                                                })()}
                                                onChange={this.handleVendorSelectionForEdit}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        label="Vendor"
                                                        placeholder="Vendor (auto-filled from invoice)"
                                                        disabled={true}
                                                    />
                                                )}
                                                style={{marginBottom: '15px'}}
                                            />
                                        </div>

                                        {this.state.loadingLineItemsForEdit && (
                                            <div style={{textAlign: 'center', margin: '20px'}}>
                                                <CircularProgress />
                                                <div>Loading line items...</div>
                                            </div>
                                        )}

                                        {this.state.selectedVendorForEdit && !this.state.loadingLineItemsForEdit && (
                                            <>
                                                <div style={{marginBottom: '10px', display: 'flex', gap: '10px', alignItems: 'center'}}>
                                                    <Button 
                                                        onClick={this.handleSelectAllLineItemsForEdit}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        Select All Available
                                                    </Button>
                                                    <Button 
                                                        onClick={this.handleDeselectAllLineItemsForEdit}
                                                        variant="outlined"
                                                        size="small"
                                                    >
                                                        Deselect All
                                                    </Button>
                                                    <TextField
                                                        label="Search by PN, PO #, or Description"
                                                        variant="outlined"
                                                        value={this.state.lineItemsSearchTerm}
                                                        onChange={this.handleLineItemsSearch}
                                                        style={{width: '300px'}}
                                                        size="small"
                                                    />
                                                    <FormControlLabel
                                                        className="validation-override"
                                                        style={{ marginLeft: 'auto', marginRight: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.overrideInvoiceQuantityForEdit}
                                                                onChange={(e) => this.setState({ overrideInvoiceQuantityForEdit: e.target.checked })}
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        }
                                                        label="Override quantity above ordered amount"
                                                    />
                                                    <div style={{fontSize: '14px', color: '#666'}}>
                                                        {this.state.selectedLineItemsForEdit.length} item(s) selected
                                                    </div>
                                                </div>

                                                <div className="parts-table-container" style={{width: '100%', maxHeight: '50vh', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px'}}>
                                                    {this.state.outstandingLineItemsForEdit.length === 0 ? (
                                                        <div style={{padding: '20px', textAlign: 'center', color: '#666'}}>
                                                            No line items found for this vendor.
                                                        </div>
                                                    ) : (
                                                        <table className="parts-table" style={{fontSize: '14px'}}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{minWidth: 50}}>Select</th>
                                                                    <th 
                                                                        style={{minWidth: 60, cursor: 'pointer', userSelect: 'none'}}
                                                                        onClick={() => this.handleSort('purchaseOrderNumber')}
                                                                    >
                                                                        PO # {this.state.sortBy === 'purchaseOrderNumber' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                                    </th>
                                                                    <th 
                                                                        style={{minWidth: 90, cursor: 'pointer', userSelect: 'none'}}
                                                                        onClick={() => this.handleSort('orderDate')}
                                                                    >
                                                                        PO Date {this.state.sortBy === 'orderDate' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                                    </th>
                                                                    <th 
                                                                        style={{minWidth: 110, cursor: 'pointer', userSelect: 'none'}}
                                                                        onClick={() => this.handleSort('partNumber')}
                                                                    >
                                                                        PN {this.state.sortBy === 'partNumber' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                                    </th>
                                                                    <th 
                                                                        style={{minWidth: 60, cursor: 'pointer', userSelect: 'none'}}
                                                                        onClick={() => this.handleSort('quantityOrdered')}
                                                                    >
                                                                        Ordered {this.state.sortBy === 'quantityOrdered' && (this.state.sortDirection === 'asc' ? '↑' : '↓')}
                                                                    </th>
                                                                    <th style={{minWidth: 70}}>On Other<br/>Invoices</th>
                                                                    <th style={{minWidth: 80}}>Available For<br/>Invoice</th>
                                                                    <th style={{minWidth: 80}}>Invoice<br/>Quantity</th>
                                                                    <th style={{minWidth: 90}}>Unit Cost</th>
                                                                    <th style={{minWidth: 100}}>Line Item<br/>Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.sortLineItems(
                                                                    this.filterOutstandingLineItems(
                                                                                                                                                 this.state.outstandingLineItemsForEdit.filter((lineItem) => {
                                                                             // For edit mode, we want to show all line items that either:
                                                                             // 1. Have outstanding quantity for invoicing, OR
                                                                             // 2. Are already attached to the current invoice being edited
                                                                             const outstandingForInvoice = this.getOutstandingQuantityForInvoice(lineItem);
                                                                             const isAlreadyAttachedToCurrentInvoice = this.state.invoiceLineItems.some(item => item.id === lineItem.id);
                                                                             return outstandingForInvoice > 0 || isAlreadyAttachedToCurrentInvoice;
                                                                         })
                                                                    )
                                                                ).map((lineItem) => {
                                                                    const isSelected = this.state.selectedLineItemsForEdit.includes(lineItem.id);
                                                                    const isExisting = this.state.invoiceLineItems.some(item => item.id === lineItem.id);
                                                                    const partDetails = lineItem.partId ? this.getPartDetails(lineItem.partId) : null;
                                                                    
                                                                    return (
                                                                        <tr key={lineItem.id} style={isExisting ? {backgroundColor: '#f0f8ff'} : {}}>
                                                                            <td>
                                                                                <Checkbox
                                                                                    checked={isSelected}
                                                                                    onChange={() => this.handleLineItemToggleForEdit(lineItem.id)}
                                                                                    color="primary"
                                                                                />
                                                                            </td>
                                                                            <td>{lineItem.purchaseOrderNumber}</td>
                                                                            <td>{new Date(lineItem.orderDate).toISOString().split('T')[0]}</td>
                                                                            <td>
                                                                                <PartDisplay 
                                                                                    part={{
                                                                                        partId: partDetails ? partDetails.partNumber : (lineItem.partFamilyName || 'Family Part'),
                                                                                        revision: partDetails ? partDetails.revision || '' : '',
                                                                                        description: partDetails ? partDetails.description : (lineItem.partFamilyName || 'Unknown')
                                                                                    }}
                                                                                    variant="table"
                                                                                    classes={this.props.classes}
                                                                                />
                                                                            </td>
                                                                            <td>{lineItem.quantityOrdered}</td>
                                                                            <td style={{color: this.getQuantityOnOtherInvoicesForEdit(lineItem.id) > 0 ? 'orange' : 'inherit', fontWeight: this.getQuantityOnOtherInvoicesForEdit(lineItem.id) > 0 ? 'bold' : 'normal'}}>
                                                                                {this.getQuantityOnOtherInvoicesForEdit(lineItem.id) || 0}
                                                                            </td>
                                                                            <td style={{color: this.getOutstandingQuantityForInvoiceEdit(lineItem) > 0 ? 'green' : 'red', fontWeight: 'bold'}}>
                                                                                {this.getOutstandingQuantityForInvoiceEdit(lineItem)}
                                                                            </td>
                                                                            <td>
                                                                                {isSelected ? (
                                                                                    <TextField
                                                                                        type="number"
                                                                                        variant="outlined"
                                                                                        error={!this.state.overrideInvoiceQuantityForEdit && parseNumberInputValue(this.state.selectedLineItemsQuantitiesForEdit?.[lineItem.id]) > this.getOutstandingQuantityForInvoiceEdit(lineItem)}
                                                                                        value={getNumberInputDisplayValue(this.state.selectedLineItemsQuantitiesForEdit?.[lineItem.id] !== undefined ? this.state.selectedLineItemsQuantitiesForEdit[lineItem.id] : this.getOutstandingQuantityForInvoiceEdit(lineItem))}
                                                                                        onChange={(e) => this.handleLineItemQuantityChangeForEdit(lineItem.id, e.target.value)}
                                                                                        inputProps={{
                                                                                            min: 1,
                                                                                            ...(this.state.overrideInvoiceQuantityForEdit ? {} : { max: this.getOutstandingQuantityForInvoiceEdit(lineItem) }),
                                                                                            'data-purchased-part-id-edit': lineItem.id
                                                                                        }}
                                                                                        size="small"
                                                                                        style={{width: 80}}
                                                                                    />
                                                                                ) : (
                                                                                    '-'
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {isSelected ? (
                                                                                    <TextField
                                                                                        type="number"
                                                                                        variant="outlined"
                                                                                        value={getNumberInputDisplayValue(this.state.selectedLineItemsUnitCostsForEdit[lineItem.id] !== undefined ? this.state.selectedLineItemsUnitCostsForEdit[lineItem.id] : this.getUnitCostForLineItemEdit(lineItem).toString())}
                                                                                        onChange={(e) => this.handleLineItemUnitCostChangeForEdit(lineItem.id, e.target.value)}
                                                                                        inputProps={{
                                                                                            min: 0,
                                                                                            step: 0.01,
                                                                                            'data-purchased-part-id-edit': lineItem.id
                                                                                        }}
                                                                                        size="small"
                                                                                        style={{width: 80}}
                                                                                    />
                                                                                ) : (
                                                                                    <span>${this.getUnitCostForLineItemEdit(lineItem).toFixed(2)}</span>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <span style={{fontWeight: 'bold'}}>
                                                                                    ${this.getLineItemTotalCostForEdit(lineItem).toFixed(2)}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>

                                                {this.state.selectedLineItemsForEdit.length > 0 && (
                                                    <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#e3f2fd', borderRadius: '4px'}}>
                                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                                            <strong>{this.state.selectedLineItemsForEdit.length} line item(s) selected for attachment</strong>
                                                            <div style={{fontSize: '16px', fontWeight: 'bold'}}>
                                                                Invoice Total: <span style={{color: '#1976d2'}}>${this.getInvoiceTotalForEdit().toFixed(2)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <div style={{marginBottom: '20px'}}>
                                        <h3>Line Items ({this.state.loadingInvoiceLineItems ? '...' : this.state.invoiceLineItems.length})</h3>
                                        {this.state.loadingInvoiceLineItems ? (
                                            <div style={{padding: '20px', textAlign: 'center', color: '#666', backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
                                                <CircularProgress size={24} style={{marginBottom: '10px'}} />
                                                <div>Loading line items...</div>
                                            </div>
                                        ) : this.state.invoiceLineItems.length === 0 ? (
                                            <div style={{padding: '20px', textAlign: 'center', color: '#666', backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
                                                No line items attached to this invoice.
                                            </div>
                                        ) : (
                                            <div className="parts-table-container" style={{width: '100%', maxHeight: '50vh', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px'}}>
                                                <table className="parts-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{minWidth: 60}}>PO #</th>
                                                            <th style={{minWidth: 110}}>Part Number</th>
                                                            <th style={{minWidth: 60}}>Ordered</th>
                                                            <th style={{minWidth: 60}}>Received</th>
                                                            <th style={{minWidth: 80}}>Invoice Qty</th>
                                                            <th style={{minWidth: 90}}>Date Attached</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.invoiceLineItems.map((lineItem) => (
                                                            <tr key={lineItem.id}>
                                                                <td>{lineItem.purchaseOrderNumber}</td>
                                                                <td>
                                                                    <PartDisplay 
                                                                        part={{
                                                                            partId: lineItem.partNumber || lineItem.partFamilyName || 'Unknown',
                                                                            revision: lineItem.partRevision || '',
                                                                            description: lineItem.description || lineItem.partDescription || lineItem.partFamilyName || 'Unknown'
                                                                        }}
                                                                        variant="table"
                                                                        classes={this.props.classes}
                                                                    />
                                                                </td>
                                                                <td>{lineItem.quantityOrdered}</td>
                                                                <td>{lineItem.quantityReceived || 0}</td>
                                                                <td style={{color: '#1976d2', fontWeight: 'bold'}}>
                                                                    {lineItem.invoiceQuantity}
                                                                </td>
                                                                <td>
                                                                    {lineItem.dateAttached ? new Date(lineItem.dateAttached).toLocaleDateString() : 'Unknown'}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                )}



                                <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px'}}>
                                    {!this.state.isEditMode && (
                                        <Button 
                                            onClick={this.handleToggleEditMode}
                                            variant="contained" 
                                            color="primary"
                                            startIcon={<FontAwesomeIcon icon={faPencilAlt} />}
                                        >
                                            Edit Invoice
                                        </Button>
                                    )}
                                    {this.state.isEditMode && (
                                        <>
                                            <Button 
                                                onClick={this.handleToggleEditMode}
                                                variant="outlined"
                                            >
                                                Cancel Edit
                                            </Button>
                                            <Button 
                                                onClick={this.handleUpdateInvoice}
                                                variant="contained" 
                                                color="primary"
                                                disabled={this.state.savingInvoice}
                                                startIcon={<FontAwesomeIcon icon={faLink} />}
                                            >
                                                {this.state.savingInvoice ? 'Saving...' : `Save Changes`}
                                            </Button>
                                        </>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </InvoiceDetailsFrame>
            </DashboardTemplate>
        );
    }
}

export default AdminInvoices;